import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfigService} from '../../common/service/app-config.service';
import {catchError, map, Observable, throwError} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SlipService {
    title: string = 'SlipService';

    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {}

    slipConfig(): Observable<any> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/cadastre/config';
        const errorMsg = 'Error retrieving cadastre config';
        return this.http.get(url).pipe(
            map(response => {
                if (response) {
                    console.debug('response.data : ', response);
                    return response;
                } else {
                    return throwError(() => {
                        console.error(errorMsg);
                        new Error(errorMsg);
                    });
                }
            }),
            catchError(error => {
                return throwError(() => {
                    console.error(errorMsg, error);
                    return error;
                });
            })
        );
    }
}
